import { useDispatch, useSelector } from "react-redux";
import {
  useGetTransactionListDataQuery,
  useUpdateTransactionTableHeadDataMutation,
} from "../../../store/queries/Admin";
import { updateConfig } from "../../../store/slices/Admin/TransactionsList/transactionListSlice";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { useEffect, useState } from "react";
import { getFormatedDate } from "../../../utils/Functions/table";
import { toast } from "react-toastify";
import { getTransactionExportedData } from "./api";
import { subDays } from "date-fns";

const useTransactionLists = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const [isDateRangeApplied, setIsDateRangeApplied] = useState(false);
  const [isUserExcelLinkSend, setIsUserExcelLinkSend] = useState(false);
  const dispatch = useDispatch();
  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const transactionsState = useSelector((state) => state.transactionlist);
  const {
    data: transactionList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetTransactionListDataQuery({
    page_size: transactionsState?.currentPageSize,
    page: transactionsState?.currentPage,
    sort: transactionsState?.sortBy,
    sort_order: transactionsState?.sortOrder,
    search: transactionsState?.search,
    start_date: getFormatedDate(transactionsState.startDate),
    end_date: getFormatedDate(transactionsState.endDate),
  });
  const [updatetransactionFields] = useUpdateTransactionTableHeadDataMutation();
  const [date, setDate] = useState({
    startDate: transactionsState.startDate,
    endDate: transactionsState.endDate,
    key: "selection",
  });
  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentPage = 1;
      })
    );
  };
  useEffect(() => {
    if (transactionList && transactionList?.data?.total_count) {
      dispatch(
        updateConfig((state) => {
          state.totalOrderCount = transactionList?.data?.total_count ?? "0";
        })
      );
    }
    //eslint-disable-next-line
  }, [transactionList?.data?.total_count]);

  const handleClearClick = () => {
    setDate({
      startDate: subDays(new Date(), 30),
      endDate: new Date(),
      key: "selection",
    });
    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.currentPageSize = 10;
        state.startDate = subDays(new Date(), 30);
        state.endDate = new Date();
        state.search = "";
      })
    );
    setIsDateRangeApplied(false);
  };

  const handleSort = (label) => {
    if (transactionsState?.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder =
            transactionsState?.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const getRow = (feild, data) => {
    const rows = {
      common: (feild, data) => <p className="pro-mb-0">{data[feild]}</p>,
    };
    return rows?.[feild]?.(feild, data) ?? rows["common"](feild, data);
  };

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const handleExcelDownload = () => {
    dispatch(
      updateConfig((state) => {
        state.excelSendModal = !state.excelSendModal;
      })
    );
  };
  const handleDateRangeChange = (range) => {
    setIsDateRangeApplied(true);
    const startDate = range[0];
    const endDate = range[1];

    setDate({
      startDate,
      endDate,
    });

    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.startDate = startDate;
        state.endDate = endDate;
      })
    );
  };
  const handleDateChange = (range) => {
    setIsDateRangeApplied(true);
    setDate(range);
    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.startDate = range.startDate;
        state.endDate = range.endDate;
      })
    );
  };
  const modalClose = () => {
    dispatch(
      updateConfig((state) => {
        state.excelSendModal = false;
      })
    );
  };
  const sendUserExcelDownload = async (value) => {
    setIsUserExcelLinkSend(true);
    let params = {
      start_date: getFormatedDate(transactionsState.startDate),
      end_date: getFormatedDate(transactionsState.endDate),
      sort_order: transactionsState?.sortOrder,
      sort: transactionsState?.sortBy,
      search: transactionsState?.search,
      email: value?.email ?? "",
    };
    let response = await getTransactionExportedData(params);
    try {
      if (response?.status === 200) {
        toast.success(`Excel download link send successfully`);
      } else {
        toast.error(`Failed to send download link,Please try again`);
      }
    } catch (error) {
      console.error(`Failed to send link:`, error);
      toast.error(`Failed to send download link`);
    } finally {
      modalClose();
      setIsUserExcelLinkSend(false);
    }
  };

  return {
    date,
    isLoading,
    isFetching,
    tableFields,
    showEditModal,
    transactionList,
    transactionsState,
    paginationOptions,
    isDateRangeApplied,
    isUserExcelLinkSend,
    handleEditColumnsClick,
    updatetransactionFields,
    sendUserExcelDownload,
    handleDateRangeChange,
    handleExcelDownload,
    handleDateChange,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    modalClose,
    handleSort,
    refetch,
    getRow,
  };
};

export default useTransactionLists;
